exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".al-container{margin:10px}.al-container .al-toolbar{display:flex;flex-wrap:wrap;justify-content:space-between}.al-container .al-toolbar .al-toolbar-item{margin-bottom:10px}.al-container .al-toolbar .al-toolbar-item:not(:first-child){margin-left:20px}.al-container .al-toolbar .al-toolbar-item:not(:last-child){margin-right:20px}.al-container .al-table-scroll{margin-bottom:30px}.al-container .al-table-scroll .al-table-row{border-bottom:1px solid #e6e6e6}.al-container .al-table-scroll .al-table-row__extended{padding:0 0 10px 8px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./client/stylesheets/assignment-logging.css
// module id = 1241
// module chunks = 0